// TODO: decomment and make the needed changes, some changes are already made
// it is to be decided if url processing is needed

// External
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { catchError, concat, concatMap, forkJoin, last, map, Observable, of, Subject, takeUntil } from 'rxjs';
import { MAIN_PATHS, PATH_LOCATIONS, PATHS, RootPath } from '../services/values/values.service';
import { NavigationService } from '../services/navigation/navigation.component';
import { ConfigService } from '../services/config/config.service';
// Internal


@Injectable({
    providedIn: 'root'
})

export class NavigationGuard {

    private readonly onDestroy$: Subject<void> = new Subject<void>();

    constructor(
        @Inject(DOCUMENT) readonly document: any,
        private readonly router: Router,
        private readonly configService: ConfigService,
        // private readonly subscriptionsService: SubscriptionsService,
        private readonly navigationService: NavigationService
    ) {}

    /**
     * Compute data for checking available modules
     *
     * @private
     * @memberof NavigationGuard
     * @param {none}
     * @returns {AccountInfo} the computed info agregated in an object
     */
    // private _computeModulesData(): AccountInfo {
    //     const hasDataPrivacy = this.subscriptionsService.hasDataPrivacy();

    //     const accountInfo: AccountInfo = {
    //         hasDataPrivacy
    //     };
    //     return accountInfo;
    // }

    /**
     * Determine if the user has access to the current page and what he can see.
     *
     * @private
     * @memberof NavigationGuard
     * @param {none}
     * @returns {void}
     */
    private _computeAvailableModules(): void {
        // Compute account info
        // const accountInfo = this._computeModulesData();

        // const showDashboard = this._showDashboard(accountInfo);
        // this.configService.setDashboard(showDashboard);
    }

    /**
     * Determine if Dashboard module is available for user
     *
     * @private
     * @memberof NavigationGuard
     * @param {AccountInfo} accountInfo The agregated account info used to determine what the user can see
     * @returns {boolean}
     */
    // private _showDashboard(accountInfo: AccountInfo): boolean {
    //     return this.configService.getOriginalDashboard()
    //             && !accountInfo?.hasAtoConfiguration
    //             && (accountInfo?.noIdentityStandalone || accountInfo?.hasMspOrXspLevelOne);
    // }


    /**
     * Generate an array with available paths in order of priority
     * Available paths can be turned off from config.service or based on specific use cases
     *
     * @private
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {UrlTree|boolean}
     */
    private _decideMainRoute(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UrlTree|boolean> {
        return new Observable(subscriber => {
            const urlProperties = this.navigationService.processUrl(route, state);
            const redirect = [];

            // if (this.configService.getDashboard()) {
            //     redirect.push(PATH_LOCATIONS.children[PATHS.DASHBOARD].id);
            // }

            redirect.push(PATH_LOCATIONS.children[PATHS.ADMIN].id);
            redirect.push(PATH_LOCATIONS.children[PATHS.CLIENTS].id);
            redirect.push(PATH_LOCATIONS.children[PATHS.REPORTS].id);

            const firstPathSegment = urlProperties.pathPieces[0] as RootPath | undefined;
            if (firstPathSegment && MAIN_PATHS.has(firstPathSegment) && redirect.indexOf(firstPathSegment) === -1 && redirect.length > 0) {
                if (!urlProperties.queryString) {
                    const emitedValue = this.router.parseUrl(`/${redirect[0]}`);
                    subscriber.next(emitedValue);
                    subscriber.complete();
                    return;
                }
                const emitedValue = this.router.parseUrl(`/${redirect[0]}?${urlProperties.queryString}`);
                subscriber.next(emitedValue);
                subscriber.complete();
                return;
            }
            subscriber.next(true);
            subscriber.complete();
        });
    }

    /**
     * Contains the requests necessary for deciding the final user interface and redirect
     * All entries in concats are put in order of priorities. Only one path redirect and/or modal redirect should be made.
     * !List owner request must be made first because subscriptionsService.list needs info of the owner
     * ! for (const account of service.accounts) { if (account.email === this.profilesService.getOwnerEmail()).....
     *
     * @private
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {(Observable<boolean|UrlTree>)}
     */
    private processGuardRequests(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean|UrlTree> {

        return new Observable( subscriber => {
            of(true)
            .pipe(
                takeUntil(this.onDestroy$),
                concatMap(() => {
                    return forkJoin({
                        // list other very important requests, for ex subscriptions
                        dummyRequest: of(true)
                    });
                }),
                map(
                    () => {
                        // Process stuff
                        // After processing whatever is needed we compute available modules to display to user
                        this._computeAvailableModules();
                        concat(
                            // Check if path from link is available for user
                            this._decideMainRoute(route, state),
                        )
                        .pipe(
                            takeUntil(this.onDestroy$),
                            map( finalRoute => {
                                if (finalRoute !== true) {
                                    subscriber.next(finalRoute);
                                    subscriber.complete();
                                    // ! Please re test. Concat still goes on despite the fact that we have already a redirect
                                    // ! We should throw error to break the concat.
                                    // throw '';
                                }
                            }),
                            last()
                        ).subscribe({
                            next: () => {
                                subscriber.next(true);
                                subscriber.complete();
                            }
                        });
                    }
                ),
                catchError(err => {
                    console.error(err);
                    return of(err);
                 })
            ).subscribe();
        });
    }

    /**
     * Guard entrypoint
     *
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {(Observable<boolean|UrlTree>)}
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.processGuardRequests(route, state);
    }

}
